<template>
  <div class="form-custom-components">
    <div
      v-for="(el, index) in componentsData"
      :key="index"
      class="form-custom-components-content"
    >
      <h4>
        <my-tooltip
          :tooltip="el.tooltip"
          show-icon
        >
          <span>
            {{ el.title }}
          </span>
        </my-tooltip>
      </h4>
      <draggable
        tag="ul"
        :list="el.items"
        :group="{ name: 'form', pull: 'clone', put: false }"
        ghost-class="ghost"
        :sort="false"
      >
        <li
          v-for="(item, i) in el.items"
          :key="index+'-'+i"
        >
          <my-tooltip
            :tooltip="item.tooltip"
          >
            <a @click="$emit('componentAdd',item)">
              <icon-park
                v-if="item.icon"
                :icon="item.icon"
                fill="#000"
                theme="outline"
                :stroke-width="2"
                size="20"
              />
              <span style="margin-left: 5px;">{{ item.label }}</span>
            </a>
          </my-tooltip>
        </li>
      </draggable>
    </div>
  </div>
</template>

<script>
import Draggable from 'vuedraggable'
import componentsData from '@/components/components/customComponents'
import MyTooltip from '@/components/myTooltip.vue';

export default {
  components: {
    MyTooltip,
  },
  data() {
    return {
      componentsData,
    }
  },
  mounted() {
    console.log(this.componentsData);
  },
  methods: {

  },
}

</script>

<style lang='scss' scoped>
// Core variables and mixins
@import '~@core/scss/base/bootstrap-extended/include';
// Overrides user variable
@import '~@core/scss/base/components/include';
.form-custom-components{
    &-content{
        user-select: none;
        ul{
            position: relative;
            overflow: hidden;
            padding: 0 10px 10px;
            margin: 0;
            li{
                font-size: 12px;
                display: block;
                width: 48%;
                line-height: 26px;
                position: relative;
                float: left;
                left: 0;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                margin: 1%;
                color: #333;
                border: 1px solid #f4f6fc;

                &:hover{
                    color: $primary;
                    border: 1px dashed $primary;
                }
                a{
                    display: block;
                    cursor: move;
                    background: #f4f6fc;
                    border: 1px solid #f4f6fc;
                    color: #333;
                    padding: 0px 5px;
                    display: flex;
                    align-items: center;
                }
            }
        }
    }
}
</style>
<style lang="scss">
.form-custom-components{
    &-content{
        ul{
            li{
                .my-tooltip{
                    width: 100%;
                }
            }
        }
    }
}
</style>
